import src from "IMAGE";
export default { src, width: 800, height: 885, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRnAAAABXRUJQVlA4TGQAAAAvBsABAM1VICICHgiADQIAAIC9l6AfoQRwAAAOQAEAAAAAAAAAAAAAAAAAQADgEhAhgUoXcIofTbQDAAAiIpepYG2OVN7zBgmXonHAOH7+p7gfZ+gHD+mDcTRvpUVXr/aSKgsI"};
